import { Component, OnInit, Input } from '@angular/core';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { CssService } from "../../../services/css-service";
import { FullePointOfSaleService } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service';
import { PointOfSaleSummary } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';

@Component({
  selector: 'app-fulle-thumbnail-shedules',
  templateUrl: './fulle-thumbnail-shedules.component.html',
  styleUrls: ['./fulle-thumbnail-shedules.component.css']
})
export class FulleThumbnailShedulesComponent implements OnInit {

  @Input() point_of_sale: PointOfSaleSummary | null = null;
  @Input() sale_method: any;
  @Input() isLeft: boolean = false;
  @Input() isBottom: boolean = false;
  @Input() isTop: boolean = false;
  @Input() isBlock: boolean = false;

  checkOpened = '';

  constructor(
    private fulleposApi: FullePointOfSaleService,
    public cssService: CssService,
    public myDials: DialogsService
  ) { }

  ngOnInit() {
    if (this.point_of_sale && this.point_of_sale.timetables)
      this.checkOpened = this.fulleposApi.checkOpening(this.point_of_sale.timetables);
  }

  openShedulesDial() {
    if (this.point_of_sale && this.point_of_sale.timetables && this.point_of_sale?.timetables.length > 0) {
      this.myDials.openShedulesDial(this.point_of_sale, this.sale_method);
    }
  }
}
